import { ForgotPasswordForm } from "@/components/features/forgot-password/ForgotPasswordForm.tsx/ForgotPasswordForm";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  Typography,
} from "@/components/ui";
import { LawWorksLogo } from "@/components/ui/LawWorksLogo/LawWorksLogo";
import { useResetPassword } from "@/lib/data/react-query/auth/auth";
import type { APIError } from "@/lib/types";
import { redirectIfAuthenticated } from "@/lib/utils/auth";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import type { AxiosError } from "axios";
import toast from "react-hot-toast";

export const Route = createFileRoute("/forgot-password")({
  component: RouteComponent,
  beforeLoad: ({ context, location }) => {
    redirectIfAuthenticated({ session: context.session, location });
  },
});

function RouteComponent() {
  const forgotPassword = useResetPassword();
  const navigate = useNavigate();
  const onSubmit = async (data: { email: string }) => {
    try {
      await forgotPassword.mutateAsync(data.email);
      await navigate({ to: "/login" });
      toast.success("Recovery email sent, please check your email for steps");
    } catch (err: unknown) {
      toastAPIErrorMessage(
        err as AxiosError<APIError>,
        "Unable to send recovery email. Please try again.",
      );
    }
  };
  return (
    <div className="flex h-[99vh] w-[99vw] grow content-center justify-center overflow-hidden">
      <div className="sm:px-auto my-auto w-full max-w-[500px] px-4">
        <Card className="min-h-[485px] p-6">
          <CardHeader>
            <LawWorksLogo className="justify-self-center" />
          </CardHeader>
          <CardContent>
            <ForgotPasswordForm
              onSubmit={onSubmit}
              isLoading={forgotPassword.isPending}
            />
          </CardContent>
          <CardFooter className="flex flex-col items-start">
            <span className="mt-2 flex flex-wrap text-sm font-light">
              <Typography className="pr-1">Know your password?</Typography>
              <Link to="/login">
                <Typography variant="link">Login</Typography>
              </Link>
            </span>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
